import { useEffect, useState } from 'react'
import Toolbar from '../ShippingLocationsPage/Toolbar'
import Table from '../ShippingLocationsPage/Table'
import { KTSVG } from '../../../_metronic/helpers'
import axios from 'axios'
import { checkErrorAPICall } from '../../helpers/checkErrorAPICall'
import { useDispatch, useSelector } from 'react-redux'
import { portsModel } from '../PagesModels'

let cancelToken
const GET_SHIPPINGLOCATIONS = '/api/v1/database/shippinglocation'
const COLLECTSL = '/api/v1/collectbilltodata'

interface props {
    pageNumberProp?: number
}

const SLTable = ({setShippingLocation, open, setOpen, setOpenClearRateToEditModal, setNewValuesWhenRateCleared, formikValues, formFor, handleClose, notStylized, data, setOpenRemarksMessageModal, forDrayage, userData}) => {
    const dispatch = useDispatch()
    const [totalResults, setTotalResults] = useState(0)
    const [loading, setLoading] = useState(false)
    const [results, setResults] = useState([])
    const [search, setSearch] = useState('')
    const [pageNumber, setPageNumber] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [sortField, setSortField] = useState('name')
    const [sortDirection, setSortDirection] = useState('asc')

    const setSortValues = (direction, field) => {
        setSortDirection(direction)
        setSortField(field)
    }

    const [columns, setColumns] = useState([
        { title: 'Code', field: 'code', customSort: (a, b, c, d) => { setSortValues(d, 'code') }},
        { title: 'Name', field: 'name', customSort: (a, b, c, d) => { setSortValues(d, 'name') }},
        { title: 'Address', field: 'address', customSort: (a, b, c, d) => { setSortValues(d, 'address') }},
        { title: 'City', field: 'city', customSort: (a, b, c, d) => { setSortValues(d, 'city') }},
        { title: 'State', field: 'state', customSort: (a, b, c, d) => { setSortValues(d, 'state') }},
        { title: 'Zipcode', field: 'zipcode', customSort: (a, b, c, d) => { setSortValues(d, 'zipcode') }},
    ])
    const [billToDataColumns, setBillToDataColumns] = useState([
        { title: 'Name', field: 'name', customSort: (a, b, c, d) => { setSortValues(d, 'name') }},
        { title: 'City', field: 'city', customSort: (a, b, c, d) => { setSortValues(d, 'city') }},
        { title: 'State', field: 'state', customSort: (a, b, c, d) => { setSortValues(d, 'state') }},
        { title: 'Zipcode', field: 'zipcode', customSort: (a, b, c, d) => { setSortValues(d, 'zipcode') }},
        { title: 'Contact', field: 'contact', customSort: (a, b, c, d) => { setSortValues(d, 'contact') }},
        { title: 'Contact Phone', field: 'contactPhone', customSort: (a, b, c, d) => { setSortValues(d, 'contactPhone') }},
        // { title: 'BillTo', field: 'billTo'},
    ])
    const [columnsPorts, setColumnsPorts] = useState([
      { title: 'Name', field: 'name'},
      { title: 'City', field: 'cityAlias'},
      { title: 'State', field: 'stateCode'},
      { title: 'Zipcode', field: 'postalCode'},
    ])

    const ports = useSelector<any>((store) => store.pages.drayagePorts) as portsModel

    const getShippingLocations = async (props: props) => {
        setLoading(true)

        if (typeof cancelToken != typeof undefined) {
          cancelToken.cancel('Operation canceled due to new request.')
        }

        cancelToken = axios.CancelToken.source()

        // The Shipping Locations Lookup modal should only show SAVED shipping locations
        // Cities can be searched in the city dropdown field (SearchShippingLocation component)
        axios.get(formFor == 'collect' ? COLLECTSL : GET_SHIPPINGLOCATIONS, {
          cancelToken: cancelToken.token,
          params: {
            page: pageNumber + 1,
            limit: rowsPerPage,
            search: search.trim(),
            country: data?.Country,
            'sort[]': `${sortField}:${sortDirection}`,
          }
        }).then((results) => {
          setResults(results.data.data.results)
          setTotalResults(results.data.data.pagingDetails.totalResults)
          setLoading(false)
        }).catch(error => {
          checkErrorAPICall(error, dispatch, 'Shipping Locations')
        })
    }


    useEffect(() => {
      if(open){
        if(!forDrayage){
          getShippingLocations({})
        }else{
          if(data && pageNumber == 0) {
            let portsPagination = ports
            setResults(portsPagination)
          }
          else if(data && pageNumber >= 1) {
            let portsPagination = ports.slice(pageNumber * rowsPerPage, (pageNumber * rowsPerPage) * 2)
            setResults(portsPagination)
          }
          // console.log(pageContent)
          setTotalResults(ports.length)
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, pageNumber, search, rowsPerPage, sortField, sortDirection])

    return (
        <>
        <div className={`bg-secondary rounded-top py-2 px-4 ${forDrayage ? 'mb-0' : 'mb-4'}`}>
            <div className="row d-flex justify-content-between p-0 border-bottom border-light my-2">
                <div className="col-8">
                    {formFor !== 'collect' && (
                      <h5 className="modal-title">{!forDrayage ? 'Shipping Locations Lookup' : 'Ports Lookup'}</h5>
                    )}
                    {formFor === 'collect' && (
                      <h5 className="modal-title">Freight Bill To Lookup</h5>
                    )}
                </div>                
                <div className="col-1 d-flex btn btn-icon btn-sm btn-active-light-primary me-3" onClick={handleClose}>
                    <KTSVG
                        path="/media/icons/duotune/arrows/arr061.svg"
                        className="svg-icon svg-icon-2x"
                    />
                </div>
            </div>
            {!forDrayage && (
              <Toolbar
                search={search}
                setSearch={setSearch}
                columns={forDrayage? columnsPorts : formFor !== 'collect' ? columns : billToDataColumns}
                setColumns={formFor !== 'collect' ? setColumns : setBillToDataColumns}
                results={results}
                setPageNumber={setPageNumber}
                setLoading={setLoading}
                tableFor={formFor === 'collect' ? 'collect' : 'ShippingLocations'}
                getData={getShippingLocations}
                forModal={false}
                notStylized={notStylized}
                forDrayage={forDrayage}
                formFor={formFor}
              />
            )}
        </div>
            <Table
              loading={loading}
              columns={forDrayage? columnsPorts : formFor !== 'collect' ? columns : billToDataColumns}
              results={results}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              totalResults={totalResults}
              tableFor='ShippingLocations'
              getData={getShippingLocations}
              forModal={true}
              setShippingLocation={setShippingLocation}
              setNewValuesWhenRateCleared={setNewValuesWhenRateCleared}
              setOpenClearRateToEditModal={setOpenClearRateToEditModal}
              formikValues={formikValues}
              setOpen={setOpen}
              formFor={formFor}
              setOpenRemarksMessageModal={setOpenRemarksMessageModal}
              forDrayage={forDrayage}
            />
        </>
    )
}

export default SLTable